const nasobilkaDesiti = () => {
	return [
		{
			id: 1,
			priklad: '3 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '20',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '30',
		},
		{
			id: 2,
			priklad: '1 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '10',
		},
		{
			id: 3,
			priklad: '10 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '70',
				},
				{
					id: 2,
					moznost: '80',
				},
				{
					id: 3,
					moznost: '90',
				},
				{
					id: 4,
					moznost: '100',
				},
			],
			vysledek: '90',
		},
		{
			id: 4,
			priklad: '8 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '90',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '70',
				},
			],
			vysledek: '80',
		},
		{
			id: 5,
			priklad: '5 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '50',
				},
				{
					id: 2,
					moznost: '60',
				},
				{
					id: 3,
					moznost: '70',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '50',
		},
		{
			id: 6,
			priklad: '7 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '90',
				},
				{
					id: 2,
					moznost: '60',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '70',
				},
			],
			vysledek: '70',
		},
		{
			id: 7,
			priklad: '10 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '30',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '20',
		},
		{
			id: 8,
			priklad: '10 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '30',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '30',
		},
		{
			id: 9,
			priklad: '10 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '100',
				},
				{
					id: 3,
					moznost: '90',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '100',
		},
		{
			id: 10,
			priklad: '6 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '70',
				},
				{
					id: 3,
					moznost: '50',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '60',
		},
		{
			id: 11,
			priklad: '70 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '7',
		},
		{
			id: 12,
			priklad: '80 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 13,
			priklad: '100 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '10',
		},
		{
			id: 14,
			priklad: '60 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '6',
		},
		{
			id: 15,
			priklad: '80 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 16,
			priklad: '0 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '20',
				},
				{
					id: 3,
					moznost: '0',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '0',
		},
		{
			id: 17,
			priklad: '50 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '5',
		},
		{
			id: 18,
			priklad: '70 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '7',
		},
		{
			id: 19,
			priklad: '60 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost:  '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '6',
		},
		{
			id: 20,
			priklad: '10 : 10',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '1',
		},
		{
			id: 21,
			priklad: '10 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '50',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '20',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '30',
		},
		{
			id: 21,
			priklad: '10 x 1',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '0',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '10',
		},
		{
			id: 22,
			priklad: '9 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '90',
				},
				{
					id: 2,
					moznost: '80',
				},
				{
					id: 3,
					moznost: '70',
				},
				{
					id: 4,
					moznost: '60',
				},
			],
			vysledek: '90',
		},
		{
			id: 23,
			priklad: '10 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '80',
				},
				{
					id: 3,
					moznost: '90',
				},
				{
					id: 4,
					moznost: '60',
				},
			],
			vysledek: '80',
		},
		{
			id: 24,
			priklad: '10 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '70',
				},
				{
					id: 3,
					moznost: '50',
				},
				{
					id: 4,
					moznost: '60',
				},
			],
			vysledek: '50',
		},
		{
			id: 25,
			priklad: '10 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '80',
				},
				{
					id: 2,
					moznost: '60',
				},
				{
					id: 3,
					moznost: '50',
				},
				{
					id: 4,
					moznost: '70',
				},
			],
			vysledek: '70',
		},
		{
			id: 26,
			priklad: '2 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '30',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '20',
		},
		{
			id: 27,
			priklad: '3 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '30',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '30',
		},
		{
			id: 28,
			priklad: '10 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '80',
				},
				{
					id: 2,
					moznost: '70',
				},
				{
					id: 3,
					moznost: '60',
				},
				{
					id: 4,
					moznost: '50',
				},
			],
			vysledek: '60',
		},
	];
};

export default nasobilkaDesiti;
